<template>
  <picture :class="['optimized-image', { 'optimized-image--fill': fill }]">
    <source v-if="avifSrc" :srcset="avifSrc" type="image/avif" />
    <source v-if="webpSrc" :srcset="webpSrc" type="image/webp" />
    <img
      :src="fallbackSrc"
      :alt="alt"
      :class="imgClass"
      :loading="loading"
      decoding="async"
    />
  </picture>
</template>

<script>
export default {
  name: 'OptimizedImage',
  props: {
    webp: { type: String, required: true },
    avif: { type: String, default: '' },
    alt: { type: String, default: '' },
    imgClass: { type: [String, Object, Array], default: '' },
    loading: { type: String, default: 'lazy' },
    fill: { type: Boolean, default: false }
  },
  computed: {
    webpSrc() {
      return this.webp
    },
    avifSrc() {
      return this.avif
    },
    fallbackSrc() {
      return this.webp
    }
  }
}
</script>

<style scoped>
.optimized-image {
  display: block;
  max-width: 100%;
}

.optimized-image img {
  display: block;
  max-width: 100%;
  height: auto;
}

.optimized-image--fill {
  width: 100%;
  height: 100%;
  max-width: none;
}

.optimized-image--fill img {
  width: 100%;
  height: 100%;
  max-width: none;
  object-fit: cover;
}
</style>
